import { render, staticRenderFns } from "./paperclip.vue?vue&type=template&id=76dd0d44&scoped=true&"
var script = {}
import style0 from "./paperclip.vue?vue&type=style&index=0&id=76dd0d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd0d44",
  null
  
)

export default component.exports